import { Component, OnInit } from '@angular/core';
import { UserClient, UserMeResult, UserPreferenceClient } from '@clp/api';
import { IUserInfo, UserInfoService } from '@clp/auth/user-info.svc';
import { tap } from 'rxjs';

@Component({
  selector: 'clp-user-profile',
  templateUrl: './user-profile.comp.html',
  styles: [
    ':host { position: relative; }',
    'label { user-select: none; }',
    'label + div { user-select: all }',
    'h4 + hr { max-width: 25%; margin-left: 0px; }'
  ]
})

export class UserProfileComp implements OnInit {
  constructor(
    private infoSvc: UserInfoService,
    private userPrefClient: UserPreferenceClient,
    userClient: UserClient) {

    this.info = this.infoSvc.userInfoTyped();
    userClient.getMe2().pipe(
      tap(x => this.me = x.result!)
    ).subscribe();
   }

  ngOnInit() { }

  public info: IUserInfo;
  public me?: UserMeResult;
  public debug = false;

  public get showActions() {
    return false;
  }

  public get canClearMfa() {
    if(!this.me) {
      return false;
    }

    return this.me.provider?.azureB2C ?? false;
  }

  public onClickClearMfa() {
    this.userPrefClient.postMfaPreferenceClear().subscribe(s => {

    });
  }
}
